<template>
  <v-app>
    <component :is="layout">
      <router-view/>
    </component>
  </v-app>
</template>

<script>
const defaultLayout = 'outer';
export default {
  data() {
    return {
      tmxTheme: {
        //primary: '#4A89DC',
        primary: '#000000',
        secondary: '#ED5565',
        third: '#474d5d',
        fourth: '#808285',
        fifth: '#e4e9ff',
        sixth: '#1e2934',
        accent: '#FFCE54',
        error: '#eb4d4b',
        warning: '#F6BB42',
        info: '#7ed6df',
        success: '#8CC152',
      },
      samsungTheme: {
        primary: '#000000',
        secondary: '#ED5565',
        third: '#474d5d',
        fourth: '#808285',
        fifth: '#e4e9ff',
        sixth: '#1e2934',
        accent: '#FFCE54',
        error: '#eb4d4b',
        warning: '#F6BB42',
        info: '#7ed6df',
        success: '#8CC152',
      },
      huaweiTheme: {
        // primary: '#231815',
        primary: '#231815',
        secondary: '#cf0a2c',
        third: '#474d5d',
        fourth: '#808285',
        fifth: '#e4e9ff',
        sixth: '#1e2934',
        accent: '#FFCE54',
        error: '#eb4d4b',
        warning: '#F6BB42',
        info: '#7ed6df',
        success: '#8CC152',
      },
    };
  },
  computed: {
    layout() {
      return `${this.$route.meta.layout || defaultLayout}-layout`;
    },
  },
  created() {
    if (this.layoutRegexp('/tmx-stores/samsung')) {
      this.$vuetify.theme.themes.light = this.samsungTheme;
    } else if (this.layoutRegexp('/tmx-stores/huawei')) {
      this.$vuetify.theme.themes.light = this.huaweiTheme;
    } else {
      this.$vuetify.theme.themes.light = this.tmxTheme;
    }
  },
  updated() {
    if (this.layoutRegexp('/tmx-stores/samsung')) {
      this.$vuetify.theme.themes.light = this.samsungTheme;
    } else if (this.layoutRegexp('/tmx-stores/huawei')) {
      this.$vuetify.theme.themes.light = this.huaweiTheme;
    } else {
      this.$vuetify.theme.themes.light = this.tmxTheme;
    }
  },
  methods: {
    layoutRegexp(pattern) {
      const patt = new RegExp(pattern);
      return patt.test(window.location.pathname);
    },
  },
};
</script>
<style>
  h1, h2, h3 ,h4, h5, h6 {
    color: var(--v-primary-darken3);
  }
</style>
